module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "main situation"
  }, [(_vm.crumbList && _vm.crumbList.length) ? _c('div', {
    staticClass: "crumb"
  }, [_vm._l((_vm.crumbList), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "crumb_item",
      on: {
        "click": _vm.closeMask
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "order_list",
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.myAccidentList), function(item, index) {
    return _c('span', {
      key: ('accidentList_' + index),
      staticClass: "crumb_item bg_eee",
      class: {
        activeCrumb: item.recordNo == _vm.baseInfo.recordNo
      },
      on: {
        "click": function($event) {
          return _vm.reStartMask(item.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.recordNo) + "\n\t\t\t\t\t"), _c('img', {
      staticClass: "close_img",
      attrs: {
        "src": require("../../assets/images/icon/home_tab_icon_close.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.doCancel(item.id, index)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "jumpBtn"
  }, [_c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(0)
      }
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(1)
      }
    }
  }, [_vm._v("现场违法照片")]), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(2)
      }
    }
  }, [_vm._v("当事人信息")]), _vm._v(" "), (_vm.baseInfo.transportWay != 3) ? _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(3)
      }
    }
  }, [_vm._v("车辆信息")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "myJumpBtn",
    on: {
      "click": function($event) {
        return _vm.setScrollTop(4)
      }
    }
  }, [_vm._v("文书生成")])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "leftContent input_new_style",
    class: [_vm.fullVideo ? 'fullVideoClass_left' : 'original_left']
  }, [_c('el-collapse', {
    model: {
      value: (_vm.activeName_a),
      callback: function($$v) {
        _vm.activeName_a = $$v
      },
      expression: "activeName_a"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "基本信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("执法处理地点")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "organizationId", $$v)
      },
      expression: "baseInfo.organizationId"
    }
  }, _vm._l((_vm.daduiLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xwdd"),
      attrs: {
        "label": item.fullName,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("执法处理单位")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.handleOrganizationId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "handleOrganizationId", $$v)
      },
      expression: "baseInfo.handleOrganizationId"
    }
  }, _vm._l((_vm.daduiLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_gzdw"),
      attrs: {
        "label": item.fullName,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("经办人1")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.firstOperatorId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "firstOperatorId", $$v)
      },
      expression: "baseInfo.firstOperatorId"
    }
  }, _vm._l((_vm.userLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xwr1"),
      attrs: {
        "label": item.realname,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("经办人2")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.secondOperatorId),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "secondOperatorId", $$v)
      },
      expression: "baseInfo.secondOperatorId"
    }
  }, _vm._l((_vm.userLists), function(item) {
    return _c('el-option', {
      key: ((item.id) + "_xwr2"),
      attrs: {
        "label": item.realname,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("执法处理时间")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": _vm.disabled_edit,
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.baseInfo.handleTime),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "handleTime", $$v)
      },
      expression: "baseInfo.handleTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("交通方式")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.baseInfo.transportWay),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "transportWay", $$v)
      },
      expression: "baseInfo.transportWay"
    }
  }, _vm._l((_vm.tempList.trafficLists), function(item) {
    return _c('el-option', {
      key: ("" + (item.value)),
      attrs: {
        "label": item.title,
        "value": item.value
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("执法地点")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.baseInfo.location),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "location", $$v)
      },
      expression: "baseInfo.location"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.showMap
    }
  }, [_c('i', {
    staticClass: "icon_address"
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("违法地址")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "48%",
      "margin-right": "2%"
    },
    attrs: {
      "placeholder": "请输入内容",
      "fetch-suggestions": (function (e, cb) {
        _vm.getRoadCode(e, cb, 1)
      }),
      "disabled": _vm.disabled_edit
    },
    on: {
      "select": function($event) {
        return _vm.handleSelect($event, 1)
      }
    },
    model: {
      value: (_vm.baseInfo.firstRoadName),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "firstRoadName", $$v)
      },
      expression: "baseInfo.firstRoadName"
    }
  }), _vm._v(" "), _c('el-autocomplete', {
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "placeholder": "请输入内容",
      "fetch-suggestions": (function (e, cb) {
        _vm.getRoadCode(e, cb, 2)
      }),
      "disabled": _vm.disabled_edit
    },
    on: {
      "select": function($event) {
        return _vm.handleSelect($event, 2)
      }
    },
    model: {
      value: (_vm.baseInfo.secondRoadName),
      callback: function($$v) {
        _vm.$set(_vm.baseInfo, "secondRoadName", $$v)
      },
      expression: "baseInfo.secondRoadName"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("违法行为")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-autocomplete', {
    attrs: {
      "placeholder": "请输入内容",
      "fetch-suggestions": (function (e, cb) {
        _vm.getRoadCode(e, cb, 3)
      }),
      "disabled": _vm.disabled_edit
    },
    on: {
      "select": function($event) {
        return _vm.handleSelect($event, 3)
      }
    },
    model: {
      value: (_vm.autocomplete_value),
      callback: function($$v) {
        _vm.autocomplete_value = $$v
      },
      expression: "autocomplete_value"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("执法人")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_vm._v(_vm._s(_vm.baseInfo.realName))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("执法时间")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_vm._v(_vm._s(_vm.baseInfo.createTime))])])])])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeName_e),
      callback: function($$v) {
        _vm.activeName_e = $$v
      },
      expression: "activeName_e"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "现场违法照片",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "retrun_case"
  }, [(_vm.driverCardFrontImage) ? _c('img', {
    staticClass: "retrun_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.driverCardFrontImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.driverCardFrontImage)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.driverCardBackImage) ? _c('img', {
    staticClass: "retrun_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.driverCardBackImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.driverCardBackImage)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vehicleCardImage) ? _c('img', {
    staticClass: "retrun_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.vehicleCardImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.vehicleCardImage)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.idCardImage) ? _c('img', {
    staticClass: "retrun_image",
    attrs: {
      "src": _vm.getImageUrl(_vm.idCardImage) + '&time=' + new Date().getTime()
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.idCardImage)
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.otherImages), function(item, index) {
    return [(item) ? _c('img', {
      key: index,
      staticClass: "retrun_image",
      attrs: {
        "src": _vm.getImageUrl(item) + '&time=' + new Date().getTime()
      },
      on: {
        "click": function($event) {
          return _vm.previewImg(item)
        }
      }
    }) : _vm._e()]
  })], 2)])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeName_b),
      callback: function($$v) {
        _vm.activeName_b = $$v
      },
      expression: "activeName_b"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "当事人信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("姓名")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.partyName),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "partyName", $$v)
      },
      expression: "userInfos.partyName"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("联系方式")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.telephone),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "telephone", $$v)
      },
      expression: "userInfos.telephone"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("驾驶证/身份证号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.cardCode),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "cardCode", $$v)
      },
      expression: "userInfos.cardCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("现住详细地址")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.address),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "address", $$v)
      },
      expression: "userInfos.address"
    }
  })], 1)])])]), _vm._v(" "), (_vm.baseInfo.transportWay == 2) ? _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("发证机构")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.issuingAuthority),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "issuingAuthority", $$v)
      },
      expression: "userInfos.issuingAuthority"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("准驾车型")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.carClassId),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "carClassId", $$v)
      },
      expression: "userInfos.carClassId"
    }
  }, _vm._l((_vm.tempList.driList), function(item) {
    return _c('el-option', {
      key: item.CODE,
      attrs: {
        "label": item.CODE,
        "value": item.id
      }
    })
  }), 1)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.transportWay == 2) ? _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("驾驶证档案编号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.archivesCode),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "archivesCode", $$v)
      },
      expression: "userInfos.archivesCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("车牌号码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px",
      "margin-right": "10px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.car_title),
      callback: function($$v) {
        _vm.car_title = $$v
      },
      expression: "car_title"
    }
  }, _vm._l((_vm.tempList.liceList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.car_number),
      callback: function($$v) {
        _vm.car_number = $$v
      },
      expression: "car_number"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.transportWay == 2) ? _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("证件地址")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.cardAddress),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "cardAddress", $$v)
      },
      expression: "userInfos.cardAddress"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("备注")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.remark),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "remark", $$v)
      },
      expression: "userInfos.remark"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.transportWay == 1) ? _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("职业")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.job),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "job", $$v)
      },
      expression: "userInfos.job"
    }
  }, _vm._l((_vm.tempList.staList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("所属公司")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.company),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "company", $$v)
      },
      expression: "userInfos.company"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.baseInfo.transportWay != 2) ? _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("是否有异议")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.hasDissent),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "hasDissent", $$v)
      },
      expression: "userInfos.hasDissent"
    }
  }, _vm._l((_vm.tempList.dissentLists), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("备注")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.remark),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "remark", $$v)
      },
      expression: "userInfos.remark"
    }
  })], 1)])])]) : _vm._e()])])], 1), _vm._v(" "), (_vm.baseInfo.transportWay != 3) ? _c('el-collapse', {
    model: {
      value: (_vm.activeName_c),
      callback: function($$v) {
        _vm.activeName_c = $$v
      },
      expression: "activeName_c"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "车辆信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("车牌号码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px",
      "margin-right": "10px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.car_title),
      callback: function($$v) {
        _vm.car_title = $$v
      },
      expression: "car_title"
    }
  }, _vm._l((_vm.tempList.liceList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.car_number),
      callback: function($$v) {
        _vm.car_number = $$v
      },
      expression: "car_number"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("号牌种类")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.plateTypeId),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "plateTypeId", $$v)
      },
      expression: "userInfos.plateTypeId"
    }
  }, _vm._l((_vm.tempList.flaList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("车辆类型")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit,
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.userInfos.vehicleTypeId),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "vehicleTypeId", $$v)
      },
      expression: "userInfos.vehicleTypeId"
    }
  }, _vm._l((_vm.tempList.vehList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.baseInfo.transportWay == 1) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("车辆购买地")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.userInfos.buyCarAddress),
      callback: function($$v) {
        _vm.$set(_vm.userInfos, "buyCarAddress", $$v)
      },
      expression: "userInfos.buyCarAddress"
    }
  })], 1)]) : _vm._e()])])])])], 1) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeName_f),
      callback: function($$v) {
        _vm.activeName_f = $$v
      },
      expression: "activeName_f"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "文书生成",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("处罚类型")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.disabled_edit
    },
    on: {
      "change": _vm.onSetType
    },
    model: {
      value: (_vm.signParams.type),
      callback: function($$v) {
        _vm.$set(_vm.signParams, "type", $$v)
      },
      expression: "signParams.type"
    }
  }, _vm._l((_vm.tempList.punishLists), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("文书编号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.disabled_edit
    },
    on: {
      "change": _vm.onSetFileNo
    },
    model: {
      value: (_vm.signParams.fileNo),
      callback: function($$v) {
        _vm.$set(_vm.signParams, "fileNo", $$v)
      },
      expression: "signParams.fileNo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [(_vm.signParams.type == 1) ? _c('i', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v("处罚金额")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "number",
      "disabled": _vm.disabled_edit
    },
    on: {
      "change": _vm.onSetPrice
    },
    model: {
      value: (_vm.signParams.price),
      callback: function($$v) {
        _vm.$set(_vm.signParams, "price", $$v)
      },
      expression: "signParams.price"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-200"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("文书描述")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "type": "textarea",
      "maxlength": "600",
      "resize": "none",
      "show-word-limit": "",
      "disabled": _vm.disabled_edit
    },
    model: {
      value: (_vm.signContent),
      callback: function($$v) {
        _vm.signContent = $$v
      },
      expression: "signContent"
    }
  })], 1)])])])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "66px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [
    [_c('div', {
      ref: "print"
    }, [_c('img', {
      staticClass: "retrun_image",
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "src": _vm.getImageUrl(_vm.printFileUrl) + '&time=' + new Date().getTime()
      }
    })])]
  ], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightContent",
    class: {
      fullVideoClass_right: _vm.fullVideo
    }
  }, [_c('div', {
    staticClass: "left"
  }, [(_vm.videoBtnShow) ? _c('div', {
    staticClass: "videoBtnZone"
  }, [(!_vm.disabled_edit) ? _c('span', {
    attrs: {
      "id": "myBtnCase2"
    }
  }, [(_vm.remoteStatus == 'success' && !_vm.hasLocal) ? _c('el-button', {
    directives: [{
      name: "preventReClick",
      rawName: "v-preventReClick",
      value: (5000),
      expression: "5000"
    }],
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.getRoom
    }
  }, [_vm._v("视频呼叫")]) : _vm._e(), _vm._v(" "), (_vm.remoteStatus == 'danger' && !_vm.list.length) ? _c('el-button', {
    directives: [{
      name: "preventReClick",
      rawName: "v-preventReClick",
      value: (5000),
      expression: "5000"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.notInRoom
    }
  }, [_vm._v("视频呼叫")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoState == 0),
      expression: "videoState == 0"
    }],
    staticClass: "display-flex-between—new",
    staticStyle: {
      "margin-top": "478px"
    }
  }, [(_vm.localStream) ? _c('div', {
    staticClass: "userlist local",
    class: [_vm.myTempIndex === null ? _vm.myMainVideo : ''],
    attrs: {
      "id": "warp myLocal"
    },
    on: {
      "click": function($event) {
        return _vm.switchLocalMain1($event)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "local_stream"
    }
  }, [(_vm.list.length) ? _c('div', {
    staticClass: "role1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.muteLocalAudio.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "policeMuteClass",
    attrs: {
      "src": _vm.isAudio ? require('../../assets/images/pics/icon_microphone2_sel.png') : require('../../assets/images/pics/icon_microphone2_nor.png')
    }
  }), _vm._v(" "), _c('span', [_vm._v("交警")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isVedio),
      expression: "!isVedio"
    }],
    staticClass: "maskable",
    attrs: {
      "id": "mask"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.list.length && _vm.showPolice) ? _c('div', {
    staticClass: "userlist bg-white remote police",
    attrs: {
      "id": "warp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t交警\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "userlist remoteClass remote user",
      class: [_vm.myTempIndex === index ? _vm.myMainVideo : '']
    }, [(item.remoteStream) ? _c('div', {
      staticClass: "distant-stream",
      attrs: {
        "id": item.id
      },
      domProps: {
        "innerHTML": _vm._s(item.remoteStream)
      }
    }) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "display-flex margin-top-15"
  }, [(!_vm.videoBtnShow) ? _c('div', {
    staticClass: "myBtn",
    on: {
      "click": _vm.leaveRoom
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pics/icon_hang_up.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {}, [_vm._v("\n\t\t\t\t\t\t\t\t挂断\n\t\t\t\t\t\t\t")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottomBtns"
  }, [(!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.previewSignBook
    }
  }, [_vm._v("预览文书")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushSignBook
    }
  }, [_vm._v("推送文书")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.seeSignBook
    }
  }, [_vm._v("查看文书")]), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.printSignBook
    }
  }, [_vm._v("打印文书")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendSignBook
    }
  }, [_vm._v("发送文书")]), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.stopHandle
    }
  }, [_vm._v("处置终止")]) : _vm._e(), _vm._v(" "), (!_vm.disabled_edit) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.onFinish
    }
  }, [_vm._v("全流程完成")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.showVideos
    }
  }, [_vm._v("查看视频")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.closeMask
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.mapShow) ? _c('MapMask', {
    attrs: {
      "lng": _vm.lng,
      "lat": _vm.lat
    },
    on: {
      "hideMap": _vm.hideMap
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.padShow) ? _c('Pdf', {
    attrs: {
      "pdfUrl": _vm.pdfUrl
    },
    on: {
      "hidePdf": _vm.hidePdf
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.videos_state) ? _c('Videos', {
    attrs: {
      "videoJson": _vm.videoJson
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.sendState) ? _c('Send', {
    attrs: {
      "sendPhoneStr": _vm.userInfos.telephone,
      "id": _vm.roomId
    },
    on: {
      "hideSend": _vm.hideSend
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4af2cfe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhiFa/video.vue
// module id = Z8Xa
// module chunks = 4